import { render, staticRenderFns } from "./OnSiteMessageList.vue?vue&type=template&id=4f972f0e&"
import script from "./OnSiteMessageList.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports